import React, { useEffect, useState } from "react";
import { DialogActions, InputAdornment } from "@material-ui/core";
import Swal from "sweetalert2";
import * as yup from "yup";
import { FieldArray, Formik } from "formik";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { Accordion, AccordionTab } from "primereact/accordion";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import Illustration from "../../../../../partials/content/Illustration";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
  FormOutlinedTextField,
} from "../../../../../partials/content/Forms/FormField";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import { saveItemsRequest } from "../../../../../services/inventory/itemReservationService";
import { Table } from "react-bootstrap";
import SearchWarehouse from "../../warehouses/searchWarehouse";
import SearchItem from "../../items/searchItem";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import SearchItemUom from "../../items/searchItemUom";
import { Card } from "react-bootstrap";
import { getSalesReturnItems } from "../../../../../services/sales/salesService";
import SearchProductionOrderBom from "../../../production/production-order/SearchProductionOrderBom";
import SearchProductionOrderWarehouse from "../../../production/production-order/SearchProductionOrderWarehouse";
const itemsRequestSchema = yup.object().shape({
  itemsRequest: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      warehouseID: yup.number(),
      outletID: yup.number(),
      itemID: yup.number(),
      warehouseName: yup.string().required("Warehouse Location is required"),
      varCode: yup.string(),
      salesOrderItemID: yup.number(),
      qty: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Quantity is required")
        .moreThan(0, "Quantity cannot be zero or empty")
        .default(0),
      stockQty: yup.number(),
      uomID: yup.number(),
      uomName: yup.string().required("Unit is required"),
    })
  ),
});
function ItemsRequestForm({
  salesReturnID = 0,
  operationCardID = 0,
  batchID = 0,
  productionOrderID = 0,
  salesOrderItem = {
    ID: 0,
    salesOrderID: 0,
    itemID: 0,
    itemType: 0,
    itemTypeName: "",
    itemCode: "",
    itemName: "",
    varCode: "",
    qty: 0,
    uomID: 0,
    uomName: "",
    item: {
      itemType: 0,
    },
  },
  warehouseID = 0,
  warehouseName = "",
  outletID = 0,
  outletName = "",
  customerID = 0,
  onCloseDialog,
  onConfirmSave,
}) {
  const itemsRequest = [];
  if (
    salesOrderItem.item.itemType === 1 ||
    salesOrderItem.item.itemType === 4 ||
    salesOrderItem.item.itemType === 5
  ) {
    itemsRequest.push({
      ID: 0,
      warehouseID,
      warehouseName,
      outletID,
      outletName,
      customerID,
      salesOrderID: salesOrderItem.salesOrderID,
      salesOrderItemID: salesOrderItem.ID,
      operationCardID,
      productionOrderID,
      salesPosID: 0,
      salesPosItemID: 0,
      deliveryID: 0,
      itemID: salesOrderItem.itemID,
      itemType: salesOrderItem.itemType,
      itemTypeName: salesOrderItem.itemTypeName,
      itemCode: salesOrderItem.itemCode,
      itemName: salesOrderItem.itemName,
      varCode: salesOrderItem.varCode,
      qty: 0,
      uomID: salesOrderItem.uomID,
      uomName: salesOrderItem.uomName,
      deleteInd: false,
    });
  }
  let data = {
    docRef: "1",
    outletID,
    outletName,
    operationCardID,
    customerID,
    customerName: "",
    itemsRequest,
  };
  const [salesReturnItems, setSalesReturnItems] = useState([]);
  const [openSearchBom, setOpenSearchBom] = useState(false);
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [itemSelected, setItemSelected] = useState({});
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [openSearchItemType, setOpenSearchItemType] = useState(false);
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const handleGetSalesReturnItems = async (salesReturnID = 0) => {
    const response = await getSalesReturnItems(salesReturnID);
    const { data } = response.data;
    setSalesReturnItems(data.salesReturnItems);
  };
  useEffect(() => {
    if (salesReturnID > 0) {
      handleGetSalesReturnItems(salesReturnID);
    }
  }, [salesReturnID]);
  return (
    <Formik
      initialValues={data}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={itemsRequestSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        const itemRequest = { ...values };
        itemRequest.operationCardID = parseInt(itemRequest.operationCardID);
        itemRequest.outletID = parseInt(itemRequest.outletID);
        for (const item of itemRequest.itemsRequest) {
          item.operationCardID = parseInt(item.operationCardID);
          item.qty = parseInt(item.qty);
          item.outletID = parseInt(item.outletID);
        }
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Items Request ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveItemsRequest(itemRequest.itemsRequest).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          {operationCardID > 0 && batchID === 0 ? (
            <div className="row" style={{ paddingBottom: "10px" }}>
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Card>
                  <Card.Header>
                    <i className="fas fa-window-maximize"></i>
                    <span>
                      <strong>Items Request Header</strong>
                    </span>
                  </Card.Header>
                  <Card.Body>
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <FormOutlinedTextField
                          label="Item Code"
                          value={salesOrderItem.itemCode}
                          InputProps={{
                            startAdornment:
                              salesOrderItem.itemType > 0 ? (
                                <InputAdornment position="start">
                                  <BootstrapTooltip
                                    title={salesOrderItem.itemTypeName}
                                  >
                                    <i
                                      className={
                                        salesOrderItem.itemType === 1
                                          ? "fas fa-boxes text-success"
                                          : salesOrderItem.itemType === 2
                                          ? "fas fa-tools text-primary"
                                          : salesOrderItem.itemType === 3
                                          ? "fas fa-building text-info"
                                          : salesOrderItem.itemType === 4
                                          ? "fas fa-boxes text-warning"
                                          : salesOrderItem.itemType === 5
                                          ? "fas fa-boxes text-danger"
                                          : null
                                      }
                                    ></i>
                                  </BootstrapTooltip>
                                </InputAdornment>
                              ) : null,
                            readOnly: true,
                          }}
                        />
                        <CustomOutlinedDisabledTextField
                          label="Item Name"
                          value={salesOrderItem.itemName}
                        />
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <CustomOutlinedDisabledTextField
                          label="Quantity"
                          value={salesOrderItem.qty}
                        />
                        <CustomOutlinedDisabledTextField
                          label="Unit"
                          value={salesOrderItem.uomName}
                        />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          ) : null}
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Request Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <FieldArray name="itemsRequest">
                        {({ push, remove }) => (
                          <React.Fragment>
                            <div className="row">
                              <div className="col-sm-12 col-md-12 col-lg-12">
                                <div className="card">
                                  <Table borderless size="sm" responsive="xl">
                                    {values.itemsRequest &&
                                    values.itemsRequest.length > 0 ? (
                                      <thead className="text-center">
                                        <tr>
                                          <th style={{ width: "40%" }}>
                                            Item Name
                                          </th>
                                          <th style={{ width: "30%" }}>
                                            Warehouse Name
                                          </th>
                                          <th style={{ width: "10%" }}>
                                            Quantity
                                          </th>
                                          <th style={{ width: "15%" }}>Unit</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                    ) : null}
                                    <tbody>
                                      {values.itemsRequest &&
                                      values.itemsRequest.length > 0 ? (
                                        values.itemsRequest.map(
                                          (item, index) => (
                                            <tr key={index}>
                                              <td>
                                                <FormOutlinedNoMarginTextField
                                                  value={`${item.itemCode} ${item.itemName}`}
                                                  InputProps={{
                                                    startAdornment:
                                                      item.itemType > 0 ? (
                                                        <InputAdornment position="start">
                                                          <BootstrapTooltip
                                                            title={
                                                              item.itemTypeName
                                                            }
                                                          >
                                                            <i
                                                              className={
                                                                item.itemType ===
                                                                1
                                                                  ? "fas fa-boxes text-success"
                                                                  : item.itemType ===
                                                                    2
                                                                  ? "fas fa-tools text-primary"
                                                                  : item.itemType ===
                                                                    3
                                                                  ? "fas fa-building text-info"
                                                                  : item.itemType ===
                                                                    4
                                                                  ? "fas fa-boxes text-warning"
                                                                  : item.itemType ===
                                                                    5
                                                                  ? "fas fa-boxes text-danger"
                                                                  : null
                                                              }
                                                            ></i>
                                                          </BootstrapTooltip>
                                                        </InputAdornment>
                                                      ) : null,
                                                    readOnly: true,
                                                  }}
                                                />
                                              </td>
                                              <td>
                                                <FormArrayTextField
                                                  arrayPropName="itemsRequest"
                                                  index={index}
                                                  propName="warehouseName"
                                                  searchButton
                                                  margin="none"
                                                  readonly
                                                  onSearchClick={() => {
                                                    setSelectedIndex(index);
                                                    setOpenSearchWarehouse(
                                                      true
                                                    );
                                                  }}
                                                />
                                              </td>
                                              <td>
                                                <FormArrayTextField
                                                  arrayPropName="itemsRequest"
                                                  index={index}
                                                  propName="qty"
                                                  quantityField
                                                  margin="none"
                                                  readonly={
                                                    salesReturnID > 0
                                                      ? true
                                                      : false
                                                  }
                                                />
                                              </td>
                                              <td>
                                                {operationCardID > 0 ||
                                                salesReturnID > 0 ||
                                                productionOrderID > 0 ? (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsRequest"
                                                    index={index}
                                                    propName="uomName"
                                                    margin="none"
                                                    readonly
                                                  />
                                                ) : (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsRequest"
                                                    index={index}
                                                    propName="uomName"
                                                    searchButton
                                                    margin="none"
                                                    readonly
                                                    onSearchClick={() => {
                                                      setSelectedIndex(index);
                                                      setItemSelected(item);
                                                      setOpenSearchUom(true);
                                                    }}
                                                  />
                                                )}
                                              </td>
                                              <td
                                                style={{
                                                  whiteSpace: "nowrap",
                                                }}
                                                className="text-center"
                                              >
                                                <BootstrapTooltip
                                                  title={
                                                    item.deleteInd
                                                      ? "Undo Delete"
                                                      : "Delete Request Item"
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className={`btn btn-icon btn-label-${
                                                      item.deleteInd
                                                        ? "warning"
                                                        : "danger"
                                                    } btn-md btn-circle mx-1`}
                                                    onClick={() => {
                                                      setSelectedIndex(-1);
                                                      if (item.ID > 0) {
                                                        setFieldValue(
                                                          "itemsPickedReservation[" +
                                                            index +
                                                            "].deleteInd",
                                                          !item.deleteInd
                                                        );
                                                      } else {
                                                        remove(index);
                                                      }
                                                    }}
                                                  >
                                                    {item.deleteInd ? (
                                                      <i className="fas fa-undo-alt"></i>
                                                    ) : (
                                                      <i className="fas fa-trash-alt"></i>
                                                    )}
                                                  </button>
                                                </BootstrapTooltip>
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            className="text-center py-3"
                                            colSpan="5"
                                          >
                                            <Illustration
                                              imageSource="INVIFO Procurement.png"
                                              guidance="You don't have any Requested items yet"
                                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                              size="sm"
                                            ></Illustration>
                                          </td>
                                        </tr>
                                      )}
                                      <tr>
                                        <td
                                          className="text-center py-3"
                                          colSpan="5"
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                            onClick={() => {
                                              if (operationCardID > 0) {
                                                if (
                                                  salesOrderItem.item
                                                    .itemType === 1 ||
                                                  salesOrderItem.item
                                                    .itemType === 4 ||
                                                  salesOrderItem.item
                                                    .itemType === 5
                                                ) {
                                                  push({
                                                    ID: 0,
                                                    warehouseID,
                                                    warehouseName,
                                                    outletID,
                                                    outletName,
                                                    customerID,
                                                    salesOrderID:
                                                      salesOrderItem.salesOrderID,
                                                    salesOrderItemID:
                                                      salesOrderItem.ID,
                                                    operationCardID:
                                                      values.operationCardID,
                                                    salesPosID: 0,
                                                    salesPosItemID: 0,
                                                    deliveryID: 0,
                                                    itemID:
                                                      salesOrderItem.itemID,
                                                    itemType:
                                                      salesOrderItem.itemType,
                                                    itemTypeName:
                                                      salesOrderItem.itemTypeName,
                                                    itemCode:
                                                      salesOrderItem.itemCode,
                                                    itemName:
                                                      salesOrderItem.itemName,
                                                    varCode:
                                                      salesOrderItem.varCode,
                                                    qty: 0,
                                                    uomID: salesOrderItem.uomID,
                                                    uomName:
                                                      salesOrderItem.uomName,
                                                    deleteInd: false,
                                                  });
                                                } else {
                                                  setOpenSearchItem(true);
                                                }
                                              } else if (
                                                productionOrderID > 0
                                              ) {
                                                setOpenSearchBom(true);
                                              } else {
                                                setOpenSearchItem(true);
                                              }
                                            }}
                                          >
                                            <i className="fas fa-plus-circle"></i>
                                            Add Item Request
                                          </button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                            <DialogActions>
                              <button
                                type="button"
                                className="btn btn-label-danger btn-md btn-pill btn-bold"
                                onClick={onCloseDialog}
                              >
                                <i className="fas fa-window-close"></i>
                                Close
                              </button>
                              {values.itemsRequest &&
                              values.itemsRequest.length > 0 ? (
                                <button
                                  type="submit"
                                  className="btn btn-success btn-md btn-pill btn-bold"
                                >
                                  <i className="fas fa-save"></i>
                                  Save
                                </button>
                              ) : null}
                            </DialogActions>
                          </React.Fragment>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
          <DialogLayout
            open={openSearchUom}
            title="Search Unit of Measurement"
            onCloseDialog={() => {
              setOpenSearchUom(false);
            }}
            maxWIdth="sm"
          >
            {itemSelected.itemID > 0 ? (
              <SearchItemUom
                itemID={itemSelected.itemID}
                onSelectUom={(uom) => {
                  setFieldValue(`itemsRequest[${selectedIndex}].uomID`, uom.ID);
                  setFieldValue(
                    `itemsRequest[${selectedIndex}].uomName`,
                    uom.uomName
                  );
                  setOpenSearchUom(false);
                }}
              />
            ) : null}
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchUom(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchWarehouse}
            title="Search Warehouse"
            onCloseDialog={() => {
              setOpenSearchWarehouse(false);
            }}
            maxWIdth="md"
          >
            {productionOrderID > 0 ? (
              <SearchProductionOrderWarehouse
                productionOrderID={productionOrderID}
                onSelectWarehouse={(warehouse) => {
                  setFieldValue(
                    `itemsRequest[${selectedIndex}].warehouseID`,
                    warehouse.ID
                  );
                  setFieldValue(
                    `itemsRequest[${selectedIndex}].warehouseName`,
                    warehouse.warehouseName
                  );
                  setOpenSearchWarehouse(false);
                }}
              />
            ) : (
              <SearchWarehouse
                onSelectWarehouse={(warehouse) => {
                  setFieldValue(
                    `itemsRequest[${selectedIndex}].warehouseID`,
                    warehouse.ID
                  );
                  setFieldValue(
                    `itemsRequest[${selectedIndex}].warehouseName`,
                    warehouse.warehouseName
                  );
                  setOpenSearchWarehouse(false);
                }}
              />
            )}

            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchWarehouse(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchItemType}
            title="Select Item Type"
            onCloseDialog={() => {
              setOpenSearchItemType(false);
            }}
            maxWIdth="md"
          >
            <div className="row menu-row-modules mt-4">
              <div className="col-sm-3 col-md-3 col-lg-3">
                <div className="menu-grid-square">
                  <Card
                    className="card-select-type"
                    onClick={() => {
                      setOpenSearchItemType(false);
                      setOpenSearchItem(true);
                      setTab({
                        ID: 1,
                        title: "Sellable Items",
                        icon: "fas fa-boxes",
                      });
                    }}
                  >
                    <Card.Body>
                      <div className="menu-title mb-2">Sellable Items</div>
                      <i className="fas fa-boxes fa-4x"></i>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </div>
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchItemType(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchBom}
            title="Select Production Order BOM"
            onCloseDialog={() => {
              setOpenSearchBom(false);
            }}
            maxWIdth="md"
          >
            <SearchProductionOrderBom
              productionOrderID={productionOrderID}
              onSelectBom={(bom) => {
                const itemsRequest = [...values.itemsRequest];
                itemsRequest.push({
                  ID: 0,
                  warehouseID,
                  warehouseName,
                  outletID,
                  outletName,
                  customerID,
                  salesPosID: 0,
                  salesPosItemID: 0,
                  deliveryID: 0,
                  itemID: bom.item.ID,
                  itemType: bom.item.itemType,
                  itemTypeName: bom.item.itemTypeName,
                  itemCode: bom.item.itemCode,
                  itemName: bom.reqItemName,
                  varCode: bom.varCode,
                  qty: 0,
                  uomID: bom.uomID,
                  uomName: bom.uomName,
                  deleteInd: false,
                });
                setFieldValue("itemsRequest", itemsRequest);
                setOpenSearchBom(false);
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchBom(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchItem}
            title="Search Item"
            onCloseDialog={() => {
              setOpenSearchItem(false);
            }}
          >
            {salesReturnID === 0 ? (
              <SearchItem
                tab={tab}
                selectSellableItems={true}
                selectServiceItems={false}
                selectItemPackages={false}
                selectAssetItems={false}
                selectVariant={true}
                onSelectItem={(item, itemPackage, varCode, valueName) => {
                  const itemsRequest = [...values.itemsRequest];
                  itemsRequest.push({
                    ID: 0,
                    warehouseID,
                    warehouseName,
                    outletID,
                    outletName,
                    customerID,
                    salesOrderID: salesOrderItem.salesOrderID,
                    salesOrderItemID: salesOrderItem.ID,
                    operationCardID: values.operationCardID,
                    salesPosID: 0,
                    salesPosItemID: 0,
                    deliveryID: 0,
                    itemID: item.ID,
                    itemType: item.itemType,
                    itemTypeName: item.itemTypeName,
                    itemCode: item.itemCode,
                    itemName: item.itemName + " " + valueName,
                    varCode: varCode,
                    qty: 0,
                    uomID: item.uomID,
                    uomName: item.itemUom.uomName,
                    deleteInd: false,
                  });
                  setFieldValue("itemsRequest", itemsRequest);
                  setOpenSearchItem(false);
                }}
              />
            ) : (
              <table className="table table-borderless table-striped table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>Item Name</th>
                    <th>Qty</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {salesReturnItems.map((item, index) => (
                    <tr key={index} style={{ cursor: "pointer" }}>
                      <td>
                        <React.Fragment>
                          <button
                            type="button"
                            className="btn btn-label-success btn-sm btn-pill btn-bold"
                            onClick={() => {
                              const itemsRequest = [...values.itemsRequest];
                              itemsRequest.push({
                                ID: 0,
                                warehouseID,
                                warehouseName,
                                outletID,
                                outletName,
                                customerID,
                                salesReturnID: salesReturnID,
                                salesReturnItemID: item.ID,
                                itemID: item.ID,
                                itemType: item.itemType,
                                itemTypeName: item.itemTypeName,
                                itemCode: item.itemCode,
                                itemName: item.itemName,
                                varCode: item.varCode,
                                qty: item.qtyReturn,
                                uomID: item.uomID,
                                uomName: item.uom.uomName,
                                deleteInd: false,
                              });
                              setFieldValue("itemsRequest", itemsRequest);
                              setOpenSearchItem(false);
                            }}
                          >
                            Select <i className="fas fa-angle-double-right"></i>
                          </button>
                        </React.Fragment>
                      </td>
                      <td>{item.itemName}</td>
                      <td>{item.qtyReturn}</td>
                      <td>{item.uom.uomName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchItem(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );
}

export default ItemsRequestForm;
